import './PrivacyPolicy.css'

const PrivacyPolicyy = () => {
    return (
        <>
            <div className="pagepolicy">
                <div>
                    <h2 className='h2-policy'>PRIVACY POLICY</h2>
                    <h3 className='h3-policy'>Ultron Textiles LLP (FabInsta)</h3>
                    <p className='p-policy'>Effective Date: [Insert Date]</p>
                    <p className='p-policy'>Ultron Textiles LLP (“Ultron”, “we”, “our”, “us”), operating under the trade name FabInsta, respects your privacy and is committed to protecting your personal data.</p>
                    <p className='p-policy'>This Privacy Policy describes how we collect, use, process, disclose, and safeguard information when you access or use our website, mobile application, or related services (collectively, the “Platform”).</p>
                    <p className='p-policy'>By accessing or using the Platform, you consent to the practices described in this Policy.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>1.Legal Entity</h2>
                    <p className='p-policy'>The Platform is owned and operated by:</p>
                    <h3 className='h3-policy'>Ultron Textiles LLP</h3>
                    <p className='p-policy'>Chennai, Tamil Nadu, India</p>
                    <p className='p-policy'>Email :  <a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}> support@fabinsta.com</a> </p>
                    <p className='p-policy'>   Ultron Textiles LLP is the data controller for purposes of applicable Indian data protection laws.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>2.Scope of This Policy</h2>
                    <p className='p-policy'>This Privacy Policy applies to:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>Website users</li>
                        <li className='li-policy'>Registered business buyers</li>
                        <li className='li-policy'>Mobile app users</li>
                        <li className='li-policy'>Communication with our support team</li></ul>
                    <p className='p-policy'>This Policy does not apply to third-party websites or services linked from our Platform.</p>
                    <p className='p-policy'>The Platform is strictly intended for business users (B2B). We do not knowingly collect personal data from individuals under 18 years of age.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>3.Information We Collect</h2>
                    <p className='p-policy'> We collect the following categories of information:</p>
                    <h3 className='h3-policy'>3.1 Information You Provide</h3>
                    <ul className="ul-policy">
                        <li className='li-policy'>Company name</li>
                        <li className='li-policy'>Contact person name</li>
                        <li className='li-policy'>Email address</li>
                        <li className='li-policy'>Phone number</li>
                        <li className='li-policy'>Billing and shipping address</li>
                        <li className='li-policy'>GST and business registration details</li>
                        <li className='li-policy'>Payment details (processed via secure third-party payment providers)</li>
                        <li className='li-policy'>Account login credentials</li></ul>
                    <p className='p-policy'>We do not store complete credit/debit card information on our servers.</p>
                    <h3 className='h3-policy'>3.2 Automatically Collected Information</h3>
                    <p className='p-policy'>When you use the Platform, we may collect:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>IP address</li>
                        <li className='li-policy'>Device information</li>
                        <li className='li-policy'>Browser type</li>
                        <li className='li-policy'>Operating system</li>
                        <li className='li-policy'>Pages viewed</li>
                        <li className='li-policy'>Time spent on pages</li>
                        <li className='li-policy'>Referral source</li>
                        <li className='li-policy'>Cookies and similar tracking technologies</li></ul>
                    <p className='p-policy'>This data is used for analytics, fraud prevention, and service improvement.</p>

                </div>
                <div>
                    <h2 className='h2-policy'>4. Use of Information</h2>
                    <p className='p-policy'>We use collected information to:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>Process and fulfill orders</li>
                        <li className='li-policy'>Verify business accounts</li>
                        <li className='li-policy'>Communicate order updates</li>
                        <li className='li-policy'>Provide customer support</li>
                        <li className='li-policy'>Improve website functionality</li>
                        <li className='li-policy'>Prevent fraud and misuse</li>
                        <li className='li-policy'>Comply with legal obligations</li>
                        <li className='li-policy'>Send transactional communications</li></ul>
                    <p className='p-policy'>We may send promotional communications only where permitted by law. You may opt out at any time.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>5. Cookies & Tracking Technologies</h2>
                    <p className='p-policy'>We use cookies and similar technologies to:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>Enable website functionality</li>
                        <li className='li-policy'>Analyze user behavior</li>
                        <li className='li-policy'>Improve performance</li>
                        <li className='li-policy'>Deliver relevant advertisements</li></ul>
                    <p className='p-policy'>Third-party service providers (such as analytics and advertising partners including Meta and Google) may use cookies in accordance with their own privacy policies.</p>
                    <p className='p-policy'>You may control cookies through your browser settings.</p>
                    <p className='p-policy'>Disabling cookies may affect website functionality.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>6. Data Sharing & Disclosure</h2>
                    <p className='p-policy'>We do not sell personal data.</p>
                    <p className='p-policy'>We may share data with:</p>
                    <h3 className='h3-policy'>6.1 Service Providers</h3>
                    <p className='p-policy'>Payment processors, logistics providers, IT support, analytics providers, and marketing service providers — strictly for business operations.</p>
                    <h3 className='h3-policy'>6.2 Legal & Regulatory Authorities</h3>
                    <p className='p-policy'>Where required by law or to protect our legal rights.</p>
                    <h3 className='h3-policy'>6.3 Business Transfers</h3>
                    <p className='p-policy'>In case of merger, restructuring, acquisition, or sale of assets.</p>
                    <p className='p-policy'>All third parties are required to process data in accordance with applicable laws.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>7. Data Retention</h2>
                    <p className='p-policy'>We retain data:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>For as long as necessary to fulfill business purposes</li>
                        <li className='li-policy'>To comply with tax and legal obligations</li>
                        <li className='li-policy'>For fraud prevention and dispute resolution</li></ul>
                    <p className='p-policy'>Retention periods may vary depending on transaction type and regulatory requirements.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>8. Data Security</h2>
                    <p className='p-policy'>We implement reasonable technical and organizational security measures, including:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>SSL encryption</li>
                        <li className='li-policy'>Access controls</li>
                        <li className='li-policy'>Secure hosting environments</li>
                        <li className='li-policy'>Restricted internal access</li></ul>
                    <p className='p-policy'>However, no system is completely secure. Use of the Platform is at your own risk.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>9. Your Rights (Subject to Applicable Law)</h2>
                    <p className='p-policy'>Under applicable Indian data protection laws, you may have the right to:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>Access your personal data</li>
                        <li className='li-policy'>Request correction of inaccurate data</li>
                        <li className='li-policy'>Request deletion (subject to legal obligations)</li>
                        <li className='li-policy'>Withdraw consent (where applicable)</li>
                        <li className='li-policy'>Raise grievances regarding data usage</li></ul>
                    <p className='p-policy'>Requests may be submitted to: <a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}> support@fabinsta.com</a></p>
                    <p className='p-policy'>We may require verification before processing requests.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>10. Cross-Border Data Transfers</h2>
                    <p className='p-policy'>Your information may be processed or stored outside your state or country where necessary for service operation, subject to applicable legal safeguards.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>11. Third-Party Services</h2>
                    <p className='p-policy'>The Platform may contain links to third-party websites or integrate third-party tools (including payment gateways, analytics services, and advertising networks).</p>
                    <p className='p-policy'>We are not responsible for the privacy practices of third parties.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>12. Advertising & Analytics</h2>
                    <p className='p-policy'>We may use services such as:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>Google Analytics</li>
                        <li className='li-policy'>Google Ads</li></ul>
                    <p className='p-policy'>These services may collect anonymized usage data.</p>
                    <p className='p-policy'>You may manage ad preferences via respective third-party settings.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>13. Business-to-Business Data Processing</h2>
                    <p className='p-policy'>The Platform operates strictly in a B2B capacity.</p>
                    <p className='p-policy'>Personal data collected is primarily business contact information associated with commercial transactions.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>14. Changes to This Policy</h2>
                    <p className='p-policy'>We may update this Privacy Policy periodically.</p>
                    <p className='p-policy'>Changes become effective upon posting.</p>
                    <p className='p-policy'>Continued use of the Platform constitutes acceptance of updated terms.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>15. Grievance Officer (India Compliance)</h2>
                    <p className='p-policy'>In accordance with applicable Indian law, you may contact our Grievance Officer at:</p>
                    <p className='p-policy'>Email: <a href="support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}> support@fabinsta.com</a></p>
                    <p className='p-policy'>Location: Chennai, Tamil Nadu, India</p>
                    <p className='p-policy'>We will respond within the legally prescribed timeframe.</p>
                </div>
            </div>
        </>

    )
}

export default PrivacyPolicyy
